import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

// Prepend backend origin to internal media URLs; leave external/static as-is.
export function resolveImg(u) {
  if (!u || typeof u !== "string") return "";
  if (u.startsWith("/api/")) return `${BACKEND}${u}`;
  return u;
}

// Deep-resolve every "/api/..." string in a content object to a full URL.
export function resolveContent(node) {
  if (typeof node === "string") return node.startsWith("/api/") ? `${BACKEND}${node}` : node;
  if (Array.isArray(node)) return node.map(resolveContent);
  if (node && typeof node === "object") {
    const out = {};
    for (const k of Object.keys(node)) out[k] = resolveContent(node[k]);
    return out;
  }
  return node;
}

// ---- admin token ----
const TOKEN_KEY = "ghajoyan_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

export const cms = {
  login: (email, password) => axios.post(`${API}/auth/login`, { email, password }),
  me: () => axios.get(`${API}/auth/me`, { headers: authHeaders() }),
  getDraft: () => axios.get(`${API}/admin/content`, { headers: authHeaders() }),
  saveDraft: (draft) => axios.put(`${API}/admin/content`, draft, { headers: authHeaders() }),
  publish: () => axios.post(`${API}/admin/publish`, {}, { headers: authHeaders() }),
  resetDefaults: () => axios.post(`${API}/admin/reset-defaults`, {}, { headers: authHeaders() }),
  listMedia: () => axios.get(`${API}/admin/media`, { headers: authHeaders() }),
  uploadMedia: (file, onProgress) => {
    const fd = new FormData();
    fd.append("file", file);
    return axios.post(`${API}/admin/media`, fd, {
      headers: { ...authHeaders(), "Content-Type": "multipart/form-data" },
      onUploadProgress: onProgress,
    });
  },
  deleteMedia: (id) => axios.delete(`${API}/admin/media/${id}`, { headers: authHeaders() }),
  inquiries: () => axios.get(`${API}/admin/inquiries`, { headers: authHeaders() }),
};
